import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import {
  Box,
  Button,
  Modal,
  Typography,
  Stack,
  Paper,
  Grid,
  Divider,
  Chip,
  useTheme,
  alpha,
  Card,
  Container,
  Tooltip,
  IconButton,
  Backdrop,
  Fade,
  LinearProgress,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Tabs,
  Tab,
  Dialog,
  DialogContent,
} from '@mui/material';
import ProjectPopup from '../Project/ProjectPopup';
import { useForm, Controller } from 'react-hook-form';
import { expensesReport } from 'components/PDF';
import { ButtonGroup } from 'components/Button';
import dayjs from 'dayjs';

// Icons
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import EventNoteIcon from '@mui/icons-material/EventNote';
import AddIcon from '@mui/icons-material/Add';
import PrintIcon from '@mui/icons-material/Print';
import GetAppIcon from '@mui/icons-material/GetApp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';
import { CustomerForm } from 'components/Forms';
import DatePickerCard from 'components/Card/DatePickerCard';
import FinanceExcel from '../../components/Excel/FinanceExcel';
import FilterFinanceExpenses from '../../components/Card/FilterFinanceExpenses';
import AddpayoutForm from '../../components/Forms/AddpayoutForm';
import ExpensesHrApplyForm from '../../components/Forms/ExpensesHrApplyForm';
import { ExpensesTableApplove } from '../../components/Table';
import ExpensesApplyForm from '../../components/Forms/ExpensesApplyForm';
import { confirmAsync } from '../../utils/functions/globalDialog';
import { formatEmployeeThaiName } from '../../utils/functions/employeeName';
import { getExpenseApproverSlots } from '../../utils/functions/approverAccess';
import * as actions from '../../redux/actions';
import { useSocket } from '../../contexts/SocketContext';
import { DevWinBadge } from '../../components/DevPageBadge';

import { getBankLabel } from '../../constants/thaiBanks';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: '80%', md: '60%' },
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  maxHeight: '90vh',
  overflow: 'auto',
};

function AllExpensesList({ title, subtitle }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();

  const expenses = useSelector((state) => state.expenses);
  const projects = useSelector((state) => state.project);
  const customer = useSelector((state) => state.customer);
  const customerType = useSelector((state) => state.customerType);
  const me = useSelector((state) => state.me);
  const info = useSelector((state) => state.info);

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(new Date());
  const [paidType, setPaidType] = useState('TRANSFER');
  const [projectSelect, setProjectSelect] = useState('');
  const [budgetSelect, setBudgetSelect] = useState('');
  const [openPay, setOpenPay] = useState(false);
  const [datePay, setDatePay] = useState(new Date());
  const [exSelect, setExSelect] = useState('');
  const [slipImage, setSlipImage] = useState([]);
  const [bank, setBank] = useState();
  const [findProject, setFindProject] = useState('');
  const [search, setSearch] = useState('');
  const [dateStart, setDateStart] = useState([dayjs().subtract(1, 'month').toDate(), new Date()]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [openCustomerModal, setOpenCustomerModal] = useState(false);
  const [customerSubmitting, setCustomerSubmitting] = useState(false);
  const [customerSelect, setCustomerSelect] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [popupProjectId, setPopupProjectId] = useState(null);
  const [openPrepareModal, setOpenPrepareModal] = useState(false);
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [filterVat, setFilterVat] = useState(false);
  const [filterWithholding, setFilterWithholding] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [periodType, setPeriodType] = useState('month');
  const [periodValue, setPeriodValue] = useState(1);
  const [quickSearched, setQuickSearched] = useState(false);
  const [quickDateStart, setQuickDateStart] = useState([dayjs().subtract(1, 'month').toDate(), new Date()]);
  const [quickExpenses, setQuickExpenses] = useState(null);
  const [quickLoading, setQuickLoading] = useState(false);
  const [quickKeyword, setQuickKeyword] = useState('');
  const [openEmbedModal, setOpenEmbedModal] = useState(false);
  const [embedDetailId, setEmbedDetailId] = useState(null);

  const handleOpenEmbedModal = (id) => {
    setEmbedDetailId(id);
    setOpenEmbedModal(true);
  };
  const handleCloseEmbedModal = () => {
    setOpenEmbedModal(false);
    setEmbedDetailId(null);
  };

  const handleOpenDetailModal = (data) => {
    setDetailData(data);
    setOpenDetailModal(true);
  };

  const handleCloseDetailModal = () => {
    setOpenDetailModal(false);
    setDetailData(null);
  };

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    watch,
  } = useForm();

  const {
    control: customerControl,
    formState: { errors: customerErrors },
    handleSubmit: handleCustomerSubmit,
    reset: resetCustomer,
    setValue: setCustomerValue,
  } = useForm();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleOpenCustomerModal = () => setOpenCustomerModal(true);
  const handleCloseCustomerModal = () => {
    setOpenCustomerModal(false);
    resetCustomer();
  };

  const handleOpenPrepareModal = () => setOpenPrepareModal(true);
  const handleClosePrepareModal = () => setOpenPrepareModal(false);

  const handleExport = () => {
    const { exportToExcel } = FinanceExcel({
      data: expenses?.rows || [],
      fileName: 'expenses_report',
    });
    exportToExcel();
  };

  const handleOpenPay = (e) => {
    setOpenPay(true);
    setExSelect(e);
    const net =
      e?.net_price != null
        ? Number(e.net_price)
        : (Number(e?.price) || 0) - (Number(e?.withholding_tax) || 0);
    setValue('price', net > 0 ? net : '');
  };

  const handleClosePay = () => setOpenPay(false);

  const fetchExpenses = useCallback(async () => {
    const ds = dayjs(dateStart?.[0]);
    const de = dayjs(dateStart?.[1]);
    if (!ds.isValid() || !de.isValid()) return;

    setIsRefreshing(true);
    await dispatch(
      actions.expensesAll({
        search,
        findProject: findProject?._id,
        dateStart: ds.startOf('day').toDate(),
        dateEnd: de.endOf('day').toDate(),
        page,
        size,
      }),
    );
    setIsRefreshing(false);
  }, [dispatch, search, findProject, dateStart, page, size]);

  // เปลี่ยนคำค้น/โครงการ/ช่วงวันที่ = ผลลัพธ์ชุดใหม่ ต้องกลับไปหน้า 1 (ไม่งั้นค้างหน้าที่เกินจำนวนหน้าจริง)
  useEffect(() => {
    setPage(1);
  }, [search, findProject, dateStart]);

  useEffect(() => {
    fetchExpenses();
  }, [fetchExpenses]);

  // Socket.IO real-time listeners — ไม่ต้อง re-attach เมื่อ search/date เปลี่ยน
  const socket = useSocket();
  useEffect(() => {
    if (!socket) return;
    const refresh = () => fetchExpenses();

    socket.on('expenses:created', refresh);
    socket.on('expenses:updated', refresh);
    socket.on('expenses:deleted', refresh);
    socket.on('payout:created', refresh);

    return () => {
      socket.off('expenses:created', refresh);
      socket.off('expenses:updated', refresh);
      socket.off('expenses:deleted', refresh);
      socket.off('payout:created', refresh);
    };
  }, [socket, fetchExpenses]);

  useEffect(() => {
    dispatch(actions.projectAll({ lite: true }));
    dispatch(actions.customerAll({}));
    dispatch(actions.meGet());
    dispatch(actions.getInformation({}));
    dispatch(actions.customerTypeAll({}));
    return () => {};
  }, []);

  useEffect(() => {
    dispatch(actions.budgetAll({ project_id: projectSelect?.id }));
    return () => {};
  }, [projectSelect]);

  const handleQuickSearch = async () => {
    const now = dayjs();
    let start;
    switch (periodType) {
      case 'week': start = now.subtract(periodValue, 'week'); break;
      case 'month': start = now.subtract(periodValue, 'month'); break;
      case 'year': start = now.subtract(periodValue, 'year'); break;
      default: start = now.subtract(periodValue, 'day');
    }
    const newRange = [start.toDate(), now.toDate()];
    setQuickDateStart(newRange);
    setDateStart(newRange);
    setQuickLoading(true);
    const result = await dispatch(
      actions.expensesAll({
        dateStart: start.startOf('day').toDate(),
        dateEnd: now.endOf('day').toDate(),
        page: 1,
        size,
      }),
    );
    setPage(1);
    setQuickExpenses(result);
    setQuickLoading(false);
    setQuickSearched(true);
  };

  // auto-run quick search on first load
  useEffect(() => { handleQuickSearch(); }, []);

  const filter = useMemo(() => (expenses?.rows || []).filter((row) => {
    if (!filterVat && !filterWithholding) return true;
    if (filterVat && filterWithholding) return row?.includes_vat || row?.withholding_tax > 0;
    if (filterVat) return !!row?.includes_vat;
    if (filterWithholding) return row?.withholding_tax > 0;
    return true;
  }), [expenses?.rows, filterVat, filterWithholding]);

  const handleDelete = async (id) => {
    const confirm = await confirmAsync('ลบข้อมูล');
    if (confirm) {
      try {
        await dispatch(actions.expensesPut(id, {
          status: 'CANCEL',
          approval_actor: me?.userData?._id,
          approval_actor_name: formatEmployeeThaiName(me?.userData),
        }));
        fetchExpenses();
      } catch (error) {}
    }
  };

  const handleEdit = (id) => {
    history.push(`/finance/expenses/edit/${id}`);
  };

  const handleDetail = (id) => {
    history.push(`/finance/expenses/detail/${id}`);
  };

  const handlePreApprove = async (id) => {
    await dispatch(
      actions.expensesPut(id, {
        status: 'PREAPPROVE',
        approval_actor: me?.userData?.id,
        approval_actor_name: formatEmployeeThaiName(me?.userData),
      }),
    );
    fetchExpenses();
  };

  const handleApprove1 = async (id) => {
    await dispatch(
      actions.expensesPut(id, {
        status: 'APPROVE_1',
        approval_actor: me?.userData?.id,
        approval_actor_name: formatEmployeeThaiName(me?.userData),
      }),
    );
    fetchExpenses();
  };

  const handleApprove2 = async (id) => {
    await dispatch(
      actions.expensesPut(id, {
        status: 'APPROVE_2',
        approval_actor: me?.userData?.id,
        approval_actor_name: formatEmployeeThaiName(me?.userData),
      }),
    );
    fetchExpenses();
  };

  const handleApprove3 = async (id) => {
    await dispatch(
      actions.expensesPut(id, {
        status: 'APPROVE',
        approval_actor: me?.userData?.id,
        approval_actor_name: formatEmployeeThaiName(me?.userData),
      }),
    );
    fetchExpenses();
  };

  // อนุมัติแบบ 1 step — เก็บชื่อเป็น "ผู้มีสิทธิ์อนุมัติคนที่ 1" (info.expense_approver_1) เสมอ
  // แทนชื่อคนที่กดจริง (approval_actor id ยังเป็นคนที่กดจริงเหมือนเดิม เปลี่ยนแค่ชื่อที่โชว์)
  const handleApprove = async (id) => {
    await dispatch(
      actions.expensesPut(id, {
        status: 'APPROVE',
        approval_actor: me?.userData?.id,
        approval_actor_name: formatEmployeeThaiName(info?.expense_approver_1) || formatEmployeeThaiName(me?.userData),
      }),
    );
    fetchExpenses();
  };

  const handleSuccess = async (id) => {
    await dispatch(actions.expensesPut(id, { status: 'SUCCESS' }));
    fetchExpenses();
  };

  const handleReject1 = async (id) => {
    await dispatch(
      actions.expensesPut(id, {
        status: 'REJECT',
        approval_actor: me?.userData?.id,
        approval_actor_name: formatEmployeeThaiName(me?.userData),
      }),
    );
    fetchExpenses();
  };

  const handleReject2 = async (id) => {
    await dispatch(
      actions.expensesPut(id, {
        status: 'REJECT_2',
        approval_actor: me?.userData?.id,
        approval_actor_name: formatEmployeeThaiName(me?.userData),
      }),
    );
    fetchExpenses();
  };

  const handleReject3 = async (id) => {
    await dispatch(
      actions.expensesPut(id, {
        status: 'REJECT_3',
        approval_actor: me?.userData?.id,
        approval_actor_name: formatEmployeeThaiName(me?.userData),
      }),
    );
    fetchExpenses();
  };

  const handleReject = async (id) => {
    await dispatch(
      actions.expensesPut(id, {
        status: 'REJECT',
        approval_actor: me?.userData?.id,
        approval_actor_name: formatEmployeeThaiName(me?.userData),
      }),
    );
    fetchExpenses();
  };

  const handleHold = async (id) => {
    await dispatch(actions.expensesPut(id, { status: 'HOLD' }));
    fetchExpenses();
  };

  const handleBillPickup = async (id) => {
    await dispatch(actions.expensesPut(id, { bill_pickup: true }));
    fetchExpenses();
  };

  const handleReset = async (id) => {
    await dispatch(
      actions.expensesPut(id, {
        status: 'PENDING',
        approval_actor: me?.userData?.id,
        approval_actor_name: formatEmployeeThaiName(me?.userData),
      }),
    );
    fetchExpenses();
  };
  const handlePrepareStatus = async (id) => {
    await dispatch(actions.expensesPut(id, { status: 'PREPARE' }));
    fetchExpenses();
  };

  const handlePrint = async () => {
    // ส่งเฉพาะรายการที่ไม่รวม Reject/Cancel/Hold เข้า PDF
    const rejectedStatuses = ['REJECT', 'REJECT_2', 'REJECT_3', 'CANCEL', 'HOLD'];
    const filteredExpenses = (filter || []).filter(
      (item) => !rejectedStatuses.includes(item?.status),
    );
    expensesReport(
      { ...expenses, rows: filteredExpenses },
      { ...info, date: dateStart[0] },
    );
  };
  const onSubmitCustomer = async (data) => {
    if (customerSubmitting) return;
    setCustomerSubmitting(true);
    try {
      data.bank = {
        bank_name: bank,
        account_name: data?.bank?.account_name,
        account_number: data?.bank?.account_number,
      };
      await dispatch(actions.customerCreate(data));
      await dispatch(actions.customerAll({}));
      handleCloseCustomerModal();
    } catch (error) {
      // handle error
    } finally {
      setCustomerSubmitting(false);
    }
  };
  const handleAddCustomerFromPayment = () => {
    handleOpenCustomerModal();
  };

  const onSubmit = async (data) => {
    const confirm = await confirmAsync('บันทึกข้อมูล');
    if (confirm) {
      const dataSubmit = {
        ...data,
        paidType,
        date: dayjs(date).endOf('day').toISOString(),
        employee: me?.userData?._id,
        employee_data: me?.userData,
        budgetSelect: budgetSelect?._id,
        projectSelect,
        customer: customerSelect,
      };
      await dispatch(actions.expensesCreateWithOutNotify(dataSubmit));
      fetchExpenses();
      reset();
      handleClose();
    }
  };

  const onSubmitPay = async (data) => {
    const confirm = await confirmAsync('บันทึกข้อมูล');
    if (confirm) {
      const dataSubmit = {
        ...data,
        paidType,
        date: datePay,
        employee: me?.userData?._id,
        expenses: exSelect?.id,
        budget: exSelect?.budget?._id,
        slipImage,
      };
      await dispatch(actions.payoutCreate(dataSubmit));
      await dispatch(actions.payoutAll({}));
      await dispatch(actions.expensesPut(exSelect?._id, { status: 'SUCCESS' }));
      fetchExpenses();
      reset();
      setSlipImage([]);
      handleClosePay();
    }
  };

  const handleAddMultiPayment = async () => {
    const confirm = await confirmAsync('บันทึกข้อมูล');
    if (confirm) {
      await dispatch(actions.payoutCreate(selectedRows));
      await fetchExpenses();
      setSelectedRows([]);
    }
  };

  const handleCreatePayment = async () => {
    await dispatch(actions.paymentCreateWithExpenses({
      date,
      creater: me?.userData?._id,
      create_by: formatEmployeeThaiName(me?.userData),
    }));
    history.push('/finance/payment');
    handleClosePrepareModal();
  };

  const handleClick = () => {
    if (selectedIndex === 0) {
      handleOpen();
    }
    if (selectedIndex === 1) {
      handlePrint();
    }
    if (selectedIndex === 2) {
      handleExport();
    }
  };

  // คำนวณข้อมูลสรุป — memoized single-pass
  const summary = useMemo(() => {
    const REJECTED = ['REJECT', 'REJECT_2', 'REJECT_3', 'CANCEL', 'HOLD'];
    const PENDING_S = ['PENDING', 'APPROVE_1', 'APPROVE_2'];
    const getNet = (expense) => {
      const raw = expense?.net_price != null
        ? Number(expense.net_price)
        : (expense?.price || 0) - (expense?.withholding_tax || 0);
      return Number.isFinite(raw) ? raw : 0;
    };
    return (filter || []).reduce((acc, item) => {
      if (REJECTED.includes(item?.status)) return acc;
      acc.totalCount += 1;
      acc.totalAmount += getNet(item);
      if (PENDING_S.includes(item.status)) {
        acc.pendingCount += 1;
        acc.pendingAmount += getNet(item);
      } else if (item.status === 'APPROVE') {
        acc.approvedCount += 1;
        acc.approvedAmount += getNet(item);
      } else if (item.status === 'SUCCESS') {
        acc.successCount += 1;
        acc.successAmount += getNet(item);
      }
      return acc;
    }, { totalCount: 0, totalAmount: 0, pendingCount: 0, pendingAmount: 0, approvedCount: 0, approvedAmount: 0, successCount: 0, successAmount: 0 });
  }, [filter]);
  const { totalCount, totalAmount, pendingCount, pendingAmount, approvedCount, approvedAmount, successCount, successAmount } = summary;

  const renderModalAddPayment = () => (
    <Modal
      open={openPay}
      onClose={handleClosePay}
      aria-labelledby="modal-payment-title"
      closeAfterTransition
    >
      <Fade in={openPay}>
        <Box sx={style}>
          <Typography variant="h6" component="h2" className="mb-4">
            เพิ่มข้อมูลการชำระเงิน
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <form onSubmit={handleSubmit(onSubmitPay)}>
            <AddpayoutForm
              control={control}
              Controller={Controller}
              date={datePay}
              setDate={setDatePay}
              paidType={paidType}
              expenseData={exSelect}
              slipImage={slipImage}
              setSlipImage={setSlipImage}
            />
          </form>
        </Box>
      </Fade>
    </Modal>
  );

  const renderPrepareModal = () => (
    <Modal
      open={openPrepareModal}
      onClose={handleClosePrepareModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {/* Header */}
        <Box
          sx={{
            px: 3,
            py: 2.5,
            borderBottom: '1px solid',
            borderColor: 'divider',
            bgcolor: 'primary.main',
            color: 'white',
          }}
        >
          <Typography
            id="modal-modal-title"
            variant="h5"
            component="h2"
            sx={{ fontWeight: 600 }}
          >
            สร้างรายการจ่ายเงิน
          </Typography>
        </Box>

        {/* Content */}
        <Box
          id="modal-modal-description"
          sx={{
            p: 3,
            overflowY: 'auto',
            flex: 1,
          }}
        >
          <DatePickerCard setDate={setDate} date={date} />
        </Box>

        {/* Footer */}
        <Box
          sx={{
            px: 3,
            py: 2,
            borderTop: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
            bgcolor: 'grey.50',
          }}
        >
          <Button
            variant="outlined"
            onClick={handleClosePrepareModal}
            sx={{ minWidth: 100 }}
          >
            ยกเลิก
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ minWidth: 100 }}
            onClick={handleCreatePayment}
          >
            สร้างรายการ
          </Button>
        </Box>
      </Box>
    </Modal>
  );

  const renderModal = () => (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-expense-title"
      closeAfterTransition
    >
      <Fade in={open}>
        <Box sx={style}>
          <Typography variant="h6" component="h2" className="mb-4">
            เพิ่มรายการเบิกจ่าย
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <form onSubmit={handleSubmit(onSubmit)}>
            <ExpensesApplyForm
              control={control}
              Controller={Controller}
              date={date}
              setDate={setDate}
              paidType={paidType}
              setPaidType={setPaidType}
              projects={projects}
              setProjectSelect={setProjectSelect}
              projectSelect={projectSelect}
              setValue={setValue}
              budgetSelect={budgetSelect}
              setBudgetSelect={setBudgetSelect}
              bank={bank}
              setBank={setBank}
              customer={customer}
              onAddCustomer={handleAddCustomerFromPayment}
              setCustomerSelect={setCustomerSelect}
              watch={watch}
            />
          </form>
        </Box>
      </Fade>
    </Modal>
  );

  const renderApprovalsInfo = () => {
    const approvalMode = info?.expense_approval_mode || 'THREE_STEP';
    const isOneStep = approvalMode === 'ONE_STEP';

    return (
      <Box
        sx={{
          mb: 2,
          px: 1.5,
          py: 1,
          bgcolor: alpha(theme.palette.info.main, 0.05),
          borderRadius: 1.5,
          border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
        }}
      >
        <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
          <span
            style={{ fontWeight: 600, color: theme.palette.text.secondary }}
          >
            รูปแบบการอนุมัติ:
          </span>{' '}
          <span>
            {isOneStep ? '1 ขั้นตอน (อนุมัติครั้งเดียว)' : '3 ขั้น (ไล่ระดับ)'}
          </span>
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontSize: '0.85rem', mt: 0.5 }}
        >
          <span
            style={{ fontWeight: 600, color: theme.palette.text.secondary }}
          >
            ผู้อนุมัติ:
          </span>{' '}
          {isOneStep ? (
            <span>
              {/* ONE_STEP = ใครก็ได้ในรายการ โชว์ครบทุกคนที่ตั้งไว้ (expense_approver_1..10) */}
              {getExpenseApproverSlots(info).filter(Boolean).map((a) => formatEmployeeThaiName(a)).join(', ')}
            </span>
          ) : (
            <span>
              ({formatEmployeeThaiName(info?.expense_approver_1)} →{' '}
              {formatEmployeeThaiName(info?.expense_approver_2)} →{' '}
              {formatEmployeeThaiName(info?.expense_approver_3)})
            </span>
          )}
        </Typography>
      </Box>
    );
  };

  const renderSummary = () => (
    <Paper
      elevation={0}
      sx={{
        mb: 2,
        borderRadius: 2,
        overflow: 'hidden',
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
      }}
    >
      <Box sx={{ p: 1.5 }}>
        <Grid container spacing={1.5}>
          <Grid item xs={6} sm={6} md={3}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: 1,
                borderRadius: 1.5,
                bgcolor: alpha(theme.palette.primary.main, 0.06),
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 1,
                  bgcolor: theme.palette.primary.main,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <ReceiptLongIcon sx={{ color: 'white', fontSize: '1.2rem' }} />
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: '0.7rem' }}
                >
                  รายการทั้งหมด
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{ lineHeight: 1.2 }}
                >
                  {totalCount}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={6} sm={6} md={3}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: 1,
                borderRadius: 1.5,
                bgcolor: alpha(theme.palette.success.main, 0.06),
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 1,
                  bgcolor: theme.palette.success.main,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CurrencyExchangeIcon
                  sx={{ color: 'white', fontSize: '1.2rem' }}
                />
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: '0.7rem' }}
                >
                  ยอดรวม
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  color="success.main"
                  sx={{ lineHeight: 1.2 }}
                >
                  ฿
                  {totalAmount
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+(?!\d))/g, '$&,')}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={6} sm={6} md={3}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: 1,
                borderRadius: 1.5,
                bgcolor: alpha(theme.palette.warning.main, 0.06),
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 1,
                  bgcolor: theme.palette.warning.main,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <TrendingUpIcon sx={{ color: 'white', fontSize: '1.2rem' }} />
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: '0.7rem' }}
                >
                  รออนุมัติ
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  color="warning.main"
                  sx={{ lineHeight: 1.2 }}
                >
                  ฿
                  {pendingAmount
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+(?!\d))/g, '$&,')}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={6} sm={6} md={3}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: 1,
                borderRadius: 1.5,
                bgcolor: alpha(theme.palette.info.main, 0.06),
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 1,
                  bgcolor: theme.palette.info.main,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <EventNoteIcon sx={{ color: 'white', fontSize: '1.2rem' }} />
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: '0.7rem' }}
                >
                  ช่วงวันที่
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight="600"
                  sx={{ lineHeight: 1.2, fontSize: '0.8rem' }}
                >
                  {dayjs(dateStart[0]).format('DD/MM')}-
                  {dayjs(dateStart[1]).format('DD/MM')}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );

  const renderTable = () => (
    <ExpensesTableApplove
      expenses={expenses}
      page={page}
      size={size}
      setPage={setPage}
      setSize={setSize}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      filter={filter}
      handlePreApprove={handlePreApprove}
      handleApprove={handleApprove}
      handleApprove1={handleApprove1}
      handleApprove2={handleApprove2}
      handleApprove3={handleApprove3}
      handleReject1={handleReject1}
      handleReject2={handleReject2}
      handleReject3={handleReject3}
      handleSuccess={handleSuccess}
      handleBillPickup={handleBillPickup}
      handleDetail={handleDetail}
      handleOpenPay={handleOpenPay}
      handleAddMultiPayment={handleAddMultiPayment}
      selectedRows={selectedRows}
      setSelectedRows={setSelectedRows}
      handleReject={handleReject}
      handleHold={handleHold}
      handleReset={handleReset}
      handleOpenPrepareModal={handleOpenPrepareModal}
      handlePrepareStatus={handlePrepareStatus}
      handleOpenDetailModal={handleOpenDetailModal}
      onRowDoubleClick={handleOpenEmbedModal}
      onDoubleClickProject={(pid) => setPopupProjectId(pid)}
      me={me}
      info={info}
    />
  );

  const options = ['CREATE EXPENSE', 'PRINT REPORT', 'EXPORT TO EXCEL'];

  const periodLabel = { day: 'วัน', week: 'อาทิตย์', month: 'เดือน', year: 'ปี' };

  const handleQuickReset = () => {
    setQuickSearched(false);
    setPeriodType('day');
    setPeriodValue(1);
    setQuickKeyword('');
  };

  const renderQuickSearchTab = () => {
    const now = dayjs();
    let previewStart;
    switch (periodType) {
      case 'week': previewStart = now.subtract(periodValue, 'week'); break;
      case 'month': previewStart = now.subtract(periodValue, 'month'); break;
      case 'year': previewStart = now.subtract(periodValue, 'year'); break;
      default: previewStart = now.subtract(periodValue, 'day');
    }
    return (
      <Box>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 1.5, sm: 2 },
            mb: 2,
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: alpha(theme.palette.primary.main, 0.03),
          }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            flexWrap="wrap"
          >
            <Typography variant="body2" fontWeight="bold" sx={{ flexShrink: 0, color: 'text.secondary' }}>
              ค้นหาย้อนหลัง
            </Typography>

            <ToggleButtonGroup
              value={periodType}
              exclusive
              onChange={(_, val) => { if (val) setPeriodType(val); }}
              size="small"
              sx={{ flexShrink: 0 }}
            >
              {['day', 'week', 'month', 'year'].map((t) => (
                <ToggleButton
                  key={t}
                  value={t}
                  sx={{
                    px: 1.5,
                    py: 0.5,
                    fontSize: '0.78rem',
                    fontWeight: periodType === t ? 'bold' : 'normal',
                  }}
                >
                  {periodLabel[t]}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>

            <TextField
              type="number"
              size="small"
              value={periodValue}
              onChange={(e) => {
                const v = parseInt(e.target.value, 10);
                if (!Number.isNaN(v) && v >= 1) setPeriodValue(v);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleQuickSearch();
                if (e.key === 'Escape') handleQuickReset();
              }}
              inputProps={{ min: 1, max: 999 }}
              label={periodLabel[periodType]}
              sx={{ width: 90 }}
            />

            <Stack direction="row" spacing={0.5} sx={{ flexShrink: 0 }}>
              {[1, 3, 7].map((v) => (
                <Button
                  key={v}
                  size="small"
                  variant={periodValue === v ? 'contained' : 'outlined'}
                  color="primary"
                  onClick={() => setPeriodValue(v)}
                  sx={{ minWidth: 36, px: 1, py: 0.5, fontSize: '0.78rem', borderRadius: 1.5 }}
                >
                  {v}
                </Button>
              ))}
            </Stack>

            <Button
              variant="contained"
              size="small"
              onClick={handleQuickSearch}
              disabled={quickLoading}
              sx={{ borderRadius: 1.5, flexShrink: 0 }}
            >
              {quickLoading ? 'กำลังโหลด...' : 'ค้นหา'}
            </Button>

            {quickSearched && (
              <Button
                variant="outlined"
                size="small"
                onClick={handleQuickReset}
                sx={{ borderRadius: 1.5, flexShrink: 0 }}
              >
                คืนค่า
              </Button>
            )}

            <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
              {previewStart.format('DD/MM/YYYY')} — {now.format('DD/MM/YYYY')}
            </Typography>
          </Stack>
        </Paper>

        {!quickSearched ? (
          <Paper
            elevation={0}
            sx={{
              p: 6,
              textAlign: 'center',
              borderRadius: 2,
              border: '1px dashed',
              borderColor: 'divider',
              bgcolor: 'background.default',
            }}
          >
            <Typography variant="h6" color="text.secondary" gutterBottom>
              กำหนดช่วงเวลาแล้วกด "ค้นหา"
            </Typography>
            <Typography variant="body2" color="text.disabled">
              เลือก วัน / อาทิตย์ / เดือน / ปี และใส่จำนวน จากนั้นกดปุ่มค้นหา
            </Typography>
          </Paper>
        ) : (
          <>
            {renderSummary()}
            <Box sx={{ mb: 2 }}>
              <TextField
                size="small"
                fullWidth
                placeholder="ค้นหาจากชื่อรายการ, รหัสเอกสาร..."
                value={quickKeyword}
                onChange={(e) => setQuickKeyword(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Escape') handleQuickReset(); }}
                label="ค้นหาในผลลัพธ์"
              />
            </Box>
            <ExpensesTableApplove
            expenses={expenses}
            page={page}
            size={size}
            setPage={setPage}
            setSize={setSize}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            filter={quickKeyword.trim()
              ? filter.filter((row) => {
                  const kw = quickKeyword.trim().toLowerCase();
                  return (
                    (row?.name || '').toLowerCase().includes(kw) ||
                    (row?.code || '').toLowerCase().includes(kw)
                  );
                })
              : filter}
            handlePreApprove={handlePreApprove}
            handleApprove={handleApprove}
            handleApprove1={handleApprove1}
            handleApprove2={handleApprove2}
            handleApprove3={handleApprove3}
            handleReject1={handleReject1}
            handleReject2={handleReject2}
            handleReject3={handleReject3}
            handleSuccess={handleSuccess}
            handleBillPickup={handleBillPickup}
            handleDetail={handleDetail}
            handleOpenPay={handleOpenPay}
            handleAddMultiPayment={handleAddMultiPayment}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            handleReject={handleReject}
            handleHold={handleHold}
            handleReset={handleReset}
            handleOpenPrepareModal={handleOpenPrepareModal}
            handlePrepareStatus={handlePrepareStatus}
            handleOpenDetailModal={handleOpenDetailModal}
            onRowDoubleClick={handleOpenEmbedModal}
            onDoubleClickProject={(pid) => setPopupProjectId(pid)}
            me={me}
            info={info}
          />
          </>
        )}
      </Box>
    );
  };

  const renderFiltersAndActions = () => (
    <Box sx={{ mb: 2 }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', md: 'center' }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <FilterFinanceExpenses
            project={projects}
            setFindProject={setFindProject}
            setSearch={setSearch}
            dateStart={dateStart}
            setDateStart={setDateStart}
            filterVat={filterVat}
            setFilterVat={setFilterVat}
            filterWithholding={filterWithholding}
            setFilterWithholding={setFilterWithholding}
          />
        </Box>
        <Stack
          direction="row"
          spacing={1}
          sx={{ display: { xs: 'flex', md: 'flex' }, flexShrink: 0 }}
        >

          <Button
            variant="outlined"
            size="small"
            startIcon={<PrintIcon />}
            onClick={handlePrint}
            sx={{ borderRadius: 1.5 }}
          >
            พิมพ์
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="success"
            startIcon={<GetAppIcon />}
            onClick={handleExport}
            sx={{ borderRadius: 1.5 }}
          >
            Excel
          </Button>
        </Stack>
      </Stack>
    </Box>
  );

  const renderDetailModal = () => (
    <Modal
      open={openDetailModal}
      onClose={handleCloseDetailModal}
      aria-labelledby="modal-detail-title"
      closeAfterTransition
    >
      <Fade in={openDetailModal}>
        <Box sx={style}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" component="h2" fontWeight="bold">
              รายละเอียดรายการเบิกจ่ายแบบย่อ
            </Typography>
            <IconButton onClick={handleCloseDetailModal} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider sx={{ mb: 3 }} />
          {detailData && (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">รหัสเอกสาร</Typography>
                <Typography variant="body1" fontWeight="bold" color="primary">{detailData?.code}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">วันที่ขอเบิก</Typography>
                <Typography variant="body1">{dayjs(detailData?.date).format('DD/MM/YYYY')}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">โครงการ</Typography>
                <Typography variant="body1">{detailData?.project?.name || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">งบประมาณ</Typography>
                <Typography variant="body1">
                  {detailData?.budget?.prefix}{detailData?.budget?.budget_number} {detailData?.budget?.name || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">ผู้ขอเบิก</Typography>
                <Typography variant="body1">{formatEmployeeThaiName(detailData?.employee)}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">ยอดจ่ายจริง</Typography>
                <Typography variant="h6" fontWeight="bold" color="success.main">
                  ฿{(detailData?.net_price ?? ((detailData?.price || 0) - (detailData?.withholding_tax || 0))).toFixed(2)?.replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="textSecondary">รายการเบิก</Typography>
                <Typography variant="body1">{detailData?.name}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="textSecondary">ผู้รับเงิน</Typography>
                <Box sx={{ bgcolor: 'grey.50', p: 1.5, borderRadius: 1, mt: 0.5 }}>
                  <Typography variant="body2"><b>ชื่อ:</b> {detailData?.payee?.name || '-'}</Typography>
                  <Typography variant="body2"><b>ธนาคาร:</b> {getBankLabel(detailData?.payee?.bank) || '-'}</Typography>
                  <Typography variant="body2"><b>เลขบัญชี:</b> {detailData?.payee?.account_number || '-'}</Typography>
                </Box>
              </Grid>
              {detailData?.budget && (
                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }} />
                  <Typography variant="subtitle2" color="textSecondary" gutterBottom>การใช้งบประมาณ</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                    <Typography variant="caption" sx={{ flexGrow: 1 }}>
                      ใช้งบไปแล้ว (ประเมินคร่าวๆ)
                    </Typography>
                  </Box>
                  <LinearProgress
                    variant="determinate"
                    value={Math.min(((detailData?.budget?.total_expenses || 0) + detailData?.price) / (detailData?.budget?.cost || 1) * 100, 100) || 0}
                    color={((detailData?.budget?.total_expenses || 0) + detailData?.price) / (detailData?.budget?.cost || 1) * 100 > 90 ? 'error' : 'primary'}
                    sx={{ height: 6, borderRadius: 3, mb: 1 }}
                  />
                  <Grid container spacing={1} sx={{ textAlign: 'center' }}>
                    <Grid item xs={4}>
                      <Typography variant="caption" color="textSecondary">งบตั้งต้น</Typography>
                      <Typography variant="body2" color="primary">฿{(detailData?.budget?.cost || 0).toLocaleString()}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="caption" color="textSecondary">ใช้ไปแล้ว</Typography>
                      <Typography variant="body2" color="error">฿{(detailData?.budget?.total_expenses || 0).toLocaleString()}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="caption" color="textSecondary">คงเหลือ</Typography>
                      <Typography variant="body2" color="success.main">฿{(detailData?.budget?.remain || 0).toLocaleString()}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button variant="outlined" onClick={handleCloseDetailModal}>
              ปิด
            </Button>
            <Button variant="contained" color="primary" sx={{ ml: 2 }} onClick={() => {
              const id = detailData?._id;
              handleCloseDetailModal();
              history.push(`/finance/expenses/detail/${id}`);
            }}>
              ดูรายละเอียดแบบเต็ม
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );

  const renderCustomerModal = () => (
    <Modal
      open={openCustomerModal}
      onClose={handleCloseCustomerModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 300 }}
    >
      <Fade in={openCustomerModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', sm: '80%', md: 700 },
            maxHeight: '90vh',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 0,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              p: 2,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <PersonIcon sx={{ mr: 1 }} />
              <Typography variant="h6">เพิ่มลูกค้าใหม่</Typography>
            </Box>
            <IconButton
              size="small"
              onClick={handleCloseCustomerModal}
              sx={{ color: 'white' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ p: 3, maxHeight: 'calc(90vh - 64px)', overflowY: 'auto' }}>
            <form onSubmit={handleCustomerSubmit(onSubmitCustomer)}>
              <CustomerForm
                Controller={Controller}
                control={customerControl}
                errors={customerErrors}
                customerType={customerType}
                bank={bank}
                setBank={setBank}
              />

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  mt: 3,
                  gap: 1,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleCloseCustomerModal}
                  startIcon={<CloseIcon />}
                  disabled={customerSubmitting}
                >
                  ยกเลิก
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={customerSubmitting}
                  startIcon={customerSubmitting ? <CircularProgress size={16} color="inherit" /> : <CheckCircleIcon />}
                >
                  {customerSubmitting ? 'กำลังบันทึก...' : 'บันทึกข้อมูล'}
                </Button>
              </Box>
            </form>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );

  const hasRows = !!(expenses?.rows?.length);

  return (
    <div>
      {expenses?.isLoading && hasRows && (
        <LinearProgress sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999, height: 2 }} />
      )}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={tabValue} onChange={(_, v) => setTabValue(v)}>
          <Tab label="ค้นหาด่วน" />
          <Tab label="รายการทั้งหมด" />
        </Tabs>
      </Box>

      {tabValue === 0 && renderQuickSearchTab()}

      {tabValue === 1 && (
        <>
          <div className="flex justify-end">{renderFiltersAndActions()}</div>
          {renderSummary()}
          {renderTable()}
        </>
      )}

      <DevWinBadge num={118} name="AllExpenses · Edit Expense" open={open} />
      {renderModal()}
      <DevWinBadge num={119} name="AllExpenses · Detail" open={openDetailModal} />
      {renderDetailModal()}
      <DevWinBadge num={120} name="AllExpenses · Add Payment" open={openPay} />
      {renderModalAddPayment()}
      <DevWinBadge num={121} name="AllExpenses · Customer Select" open={openCustomerModal} />
      {renderCustomerModal()}
      <DevWinBadge num={122} name="AllExpenses · Prepare" open={openPrepareModal} />
      {renderPrepareModal()}

      {/* Full Detail Popup (double-click) */}
      <DevWinBadge num={123} name="AllExpenses · Embed Detail" open={openEmbedModal} />
      <Modal open={openEmbedModal} onClose={handleCloseEmbedModal} closeAfterTransition>
        <Fade in={openEmbedModal}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: { xs: '98%', sm: '92%', md: '85%', lg: '80%' },
              height: { xs: '90vh', md: '88vh' },
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 0.5, borderBottom: '1px solid', borderColor: 'divider' }}>
              <IconButton size="small" onClick={handleCloseEmbedModal}>
                <CloseIcon />
              </IconButton>
            </Box>
            {embedDetailId && (
              <iframe
                src={`/finance/expenses/detail/${embedDetailId}?embed=1`}
                title="รายละเอียด"
                style={{ flex: 1, border: 'none', width: '100%' }}
              />
            )}
          </Box>
        </Fade>
      </Modal>

      <Dialog
        open={!!popupProjectId}
        onClose={() => setPopupProjectId(null)}
        maxWidth="xl"
        fullWidth
        sx={{ '& .MuiDialog-container': { alignItems: 'flex-start' } }}
        PaperProps={{ sx: { mt: '40px', maxHeight: 'calc(100vh - 56px)', minWidth: '50vw' } }}
        hideBackdrop
      >
        <DialogContent sx={{ p: 0 }}>
          {popupProjectId && (
            <ProjectPopup
              propId={popupProjectId}
              onClose={() => setPopupProjectId(null)}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AllExpensesList;
